import { Modal, InputGroup, Table } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import classes from "../../../Styles/common.module.css";

const PostReply = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [addData, setAddData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [columns, setColumns] = useState([]);
  // const [fileData, setFileData] = useState([]);

  const [dataToBeSelect, setDataToBeSelect] = useState({
    EMAIL_TO: [],
  })

  const [emailList, setEmailList] = useState([]);

  var emptyFile = {name: " ", size: " "}
  const fileData = [...selectedFiles, emptyFile]

  //DEPLOYMENT FILE
  const [deploymentFile, setDeploymentFile] = useState(null);

  useEffect(() => {
    if (props.dataToBeSelect !== undefined && props.dataToBeSelect !== null) {
      setDataToBeSelect({
        EMAIL_TO:
          props.dataToBeSelect=== null
            ? []
            : props.dataToBeSelect,
      });
    }
  }, [props.dataToBeSelect]);

  useEffect(() => {
    setColumns([
        {
            accessorFn: (row) => row.name,
            header: "Filename",
            size: "60",
        },
        {
            accessorFn: (row) => row.size === " " ? " " : formatSize(row.size),
            header: "Size",
            size: "10",
        },
        {
            id: "Action",
            header: "Action",
            size: "10",
            accessorFn: (row) => (
                <div>
                  {row.name !== " " 
                  ? <span>
                        <button
                            style={{
                                backgroundColor: "white",
                                border: "none",
                                alignItems: "center",
                            }}
                            onClick={(e) => clearFiles(e, row)}
                        >
                            <CloseRoundedIcon />
                        </button>
                    </span>
                  : <span>
                  <button
                      style={{
                          backgroundColor: "white",
                          border: "none",
                      }}
                      onClick={chooseFileFn}
                  >
                      <AddRoundedIcon/>
                  </button>
              </span>}          
                </div>
            ),
        }
    ])
  }, [selectedFiles])

  const clearFiles = (e, row) => {
    const newData = [...selectedFiles];

    for (let i = 0; i < newData.length; i++) {
        
        if (newData[i] === row) {
          newData.splice(i, 1);
        }
    }
    setSelectedFiles(newData);
  }

  const clearAllFiles = () => {
    setSelectedFiles([]);
    setAddData({ ATTACHMENT: undefined });
  };

  const hideModal = () => {
    setAddData([]);
    setInputError([]);
    setSelectedFiles([]);
    setDeploymentFile(null);
    setEmailList([]);
    props.onHide();
  };

  const SendEmail = (_data, _response) => {
    let functionName = "onSaveConfirmHandler";

    try {
        props.onLoading(true, "Sending email, please wait...");

        const data = {
            // TICKET_MST_ID: ticketMstId,
            TICKET_NUM: _data.TICKET_NUM,    
            ORG_ID: _data.ORG_ID,
            ORG_NAME: _data.ORG_NAME,
            SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
            SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
            RESPONSE_DETAILS: _response.RESPONSE_DETAILS,
            UPDATE_ID: userId,
        };

        http
        .post("api/Response/SendPostEmail", data, { timeout: common.DEFAULT_TIMEOUT })
        .then((response) => {
          props.onLoading(true, "Sending email...");
        })
        .catch((err) => {    
            common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
            props.onLoading(false, "Loading...");
        })
    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to send");
        common.c_LogWebError(props.page, functionName, err);
    }
  };

  const saveBtnOnClick = () => {
    var flag = true;
    const fileSizeLimit = 4 * 1024 * 1024;
    if (addData.RESPONSE_DETAILS === undefined) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        RESPONSE_DETAILS: " Response details could not be empty.",
      }));
    }
    if (Object.keys(emailList).length === 0) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        EMAIL_TO: "To could not be empty.",
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        EMAIL_TO: "",
      }));
    }
    if (
      Object.values(inputError).filter((v) => v !== "").length === 0 &&
      flag
    ) {
      PostReply();
    }
  };

  function PostReply() {
    let functionName = "";
    try {
      functionName = props.page + PostReply.name;
      props.onLoading(true, "Post reply, please wait...");

      if (selectedFiles.length !== 0 || deploymentFile) {
        const uploadedFiles = [...selectedFiles];
        const files = [];
        const formData = new FormData();

        const selectedEmailList = emailList.map((e) => e.key);

        // normal attachments
        selectedFiles.forEach((file) => {
          formData.append("file", file);
          files.push(file.name); 
        });

        // deployment form (ONLY ONE)
        if (deploymentFile) {
          formData.append("deploymentFile", deploymentFile);
        }
        
        const text = addData.RESPONSE_DETAILS.replace(/\n/g,'%0A').replace(/\r/g,'%0D');

        http
          .post(
            common.c_getApiUrl() + "api/response/InsertAttachment",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                TICKET_MST_ID: props.viewData.TICKET_MST_ID.trim(),
                TICKET_NUM: props.viewData.TICKET_NUM,
                RESPONSE_DETAILS: text,
                NEW_ATTACHMENT_NAME: files.join(","),
                EMAIL_LIST: selectedEmailList,
                CREATE_DATETIME: props.viewData.CREATE_DATETIME,
                CREATE_BY: props.viewData.CREATE_BY,
                ACKNOWLEDGED_BY: props.viewData.ACKNOWLEDGED_BY,
                UPDATE_ID: userId,
              },
            }
          )
          .then((response) => {
            if (response.data.CLOSE_STATUS === true || response.data.CANCEL_STATUS === true) {
              if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
                toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
              } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
                toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
              } 
              props.onReload();
              hideModal();
            } else {
              toast.success("Reply is successfully posted.");
              // SendEmail(props.viewData, response.data);
              props.onReload();
              hideModal();
            }
          })
          .catch((err) => {
            toast.error("Failed to post reply. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
        }
        else {
          const selectedEmailList = emailList.map((e) => e.key);
          const data = {
            TICKET_MST_ID: props.viewData.TICKET_MST_ID.trim(),
            TICKET_NUM: props.viewData.TICKET_NUM,
            RESPONSE_DETAILS: addData.RESPONSE_DETAILS.trim(),
            USER_EMAIL_LIST: selectedEmailList,
            UPDATE_ID: userId,
            CREATE_BY: props.viewData.CREATE_BY,
            ACKNOWLEDGED_BY: props.viewData.ACKNOWLEDGED_BY,
          };
          http
            .post("api/response/InsertReply", data, { timeout: 10000 })
            .then((response) => {     
              if (response.data.CLOSE_STATUS === true || response.data.CANCEL_STATUS === true) {
                if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
                  toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
                } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
                  toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
                } 
                props.onReload();
                hideModal();
              } else {
                toast.success("Reply is successfully posted.");
                // SendEmail(props.viewData, addData.RESPONSE_DETAILS);
                props.onReload();
                hideModal();
              }             
            })
            .catch((err) => {
              toast.error("Failed to post reply. Please try again.");
              common.c_LogWebError(props.page, functionName, err);
            })
            .finally(() => {
              props.onLoading(false, "Loading...");
            });
        }
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to post reply. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  const selectFileHandler = (event) => {
    let functionName = "";

    try {
      functionName = selectFileHandler.name;
      const files = event.target.files;

      if (files.length === 0) {
        setSelectedFiles([]);
        setInputError((prevState) => ({
          ...prevState,
          ATTACHMENT: "",
        }));
      } else {
        for (let i = 0; i < files.length; i++) {
          if (files[i].size <= 4 * 1024 * 1024) {
            if (selectedFiles.some(file => file.name === files[i].name)){
              setInputError((prevState) => ({
                ...prevState,
                ATTACHMENT:
                  files[i].name + " has already exist",
              }));
              toast.error(files[i].name + " has already exist");
            }
            else {
              selectedFiles.push(files[i]);
              setAddData((prevState) => ({
                ...prevState,
                ATTACHMENT: selectedFiles,
              }));
              setInputError((prevState) => ({
                ...prevState,
                ATTACHMENT: "",
              }));
            }
          } else {
            setInputError((prevState) => ({
              ...prevState,
              ATTACHMENT:
                "Attachment file could not be exceeds 4MB size limit.",
            }));
            toast.error(files[i].name + " exceeds 4MB size limit");
          }
        }

        event.target.value = null;

        setInputError((prevState) => ({
          ...prevState,
          ATTACHMENT: "",
        }));
      }
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const formatSize = (bytes) => {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  };

  const calculateTotalSize = (files) => {
    let totalSize = 0;
    files.forEach(file => {
        totalSize += file.size;
    });
    return totalSize;
};

  function chooseFileFn() {
    document.getElementById("ATTACHMENT").click();
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const selectUserEmailHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectUserEmailHandler.name;
      if (Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          EMAIL_TO: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          EMAIL_TO: " could not be empty.",
        }));
      }
      setEmailList([...val]);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const showDeploymentSection =
    props.systemAttachment &&
    props.systemAttachment.length > 0;

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header style={{ textAlign: "center" }}>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>POST REPLY</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="checkbox-container">
            <span className="checkbox-span" style={{fontWeight: "bold", cursor: "default"}}>
              RESOLVED:
            </span>
            <input
              id="RESOLVED_STATUS"
              type="checkbox"
              className="checkbox-control"
              style={{ marginRight: "180px" }}
            />
          </div> */}

          <Comp.Select
            id="EMAIL_TO"
            label="To*:"
            type="text"
            options={dataToBeSelect.EMAIL_TO}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            errorMessage={inputError.EMAIL_TO}
            value={emailList}
            onChange={selectUserEmailHandler}
            isMulti
          />
          <Comp.TextArea
            // ref={messageInputRef}
            id="RESPONSE_DETAILS"
            label="Message*:"
            name="Message"
            className="form-control"
            value={addData.RESPONSE_DETAILS}
            errorMessage={inputError.RESPONSE_DETAILS}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            id="ATTACHMENT"
            type="file"
            className="form-control"
            label="Upload File (Max. File Size 4MB per File):"
            name="Upload File"
            value={addData.ATTACHMENT}
            onChange={selectFileHandler}
            // onChange={handleFileEvent}
            accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png, .txt"
            errorMessage={inputError.ATTACHMENT}
            // hidden={selectedFiles.length !== 0}
            hidden={true}
            multiple
          />

          <div>
            <label className={classes.colFormLabel}>
              Upload File (Max. File Size 4MB per File):
            </label>
            {/* <InputGroup>
                <InputGroup.Text onClick={chooseFileFn}>
                    Choose File
                </InputGroup.Text>
                <InputGroup.Text onClick={clearAllFiles} style={{marginLeft:"0.5rem"}}>
                    Clear
                </InputGroup.Text>
            </InputGroup> */}
            <br/>
            <Comp.Table data={fileData} columns={columns} enableTopToolbar={false}/>
            <br/>
            <label style={{fontWeight: "normal"}}>{selectedFiles.length} File(s) Selected </label>
            {selectedFiles.length > 0 ? <Comp.Button type="delete" style={{float: "right"}} onClick={clearAllFiles}>Clear</Comp.Button> : null}              
            {/* <label style={{fontWeight: "normal"}}>Total File Size: {formatSize(calculateTotalSize(selectedFiles))}</label>    */}
          </div>
          {/* DEPLOYMENT FILE  */}
          { showDeploymentSection && (
              <div style={{ marginTop: "10px" }}>
                <label>Deployment Form Upload (PDF only)</label>
                <input
                    type="file"
                    accept=".pdf,application/pdf"
                    onChange={(e) => {
                      const file = e.target.files[0];

                      if (!file) return;

                      const isPdf =
                        file.type === "application/pdf" ||
                        file.name.toLowerCase().endsWith(".pdf");

                      if (!isPdf) {
                        toast.error("Deployment Form only accepts PDF file.");
                        e.target.value = null;
                        setDeploymentFile(null);
                        return;
                      }

                      if (file.size > 4 * 1024 * 1024) {
                        toast.error("Deployment Form file cannot exceed 4MB.");
                        e.target.value = null;
                        setDeploymentFile(null);
                        return;
                      }

                      setDeploymentFile(file);
                    }}
                  />
              </div>
              )
            }
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button id="btnSave" type="general" onClick={saveBtnOnClick}>
              Save
            </Comp.Button>
            {/* &nbsp; &nbsp; &nbsp; &nbsp;  */}
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PostReply;
